// extracted by mini-css-extract-plugin
export default {"image":"Accordion_image__xDfLp","item":"Accordion_item__gfUay","content":"Accordion_content__90rKm","active":"Accordion_active__thP-A","material":"Accordion_material__LuJcP"};